import layoutAdmin from '@/layouts/layoutAdmin.vue';

//Documents management
import documentsUpload from '@/views/module/documents/documentsManagement/documentsUpload.vue';

export default 
[
    {
        path: '/module',
        component: layoutAdmin,
        meta: {
            UserLoggedIn: true,
        },
        children: [

            // Documents Management

            {
                path: "documents",
                name: "documents",
                meta: {
                    breadcrumb: ['Documents Upload']
                },
                component: documentsUpload,
            },
            
        ],

    },
    
]